import { Component, EventEmitter, inject, Input, OnInit, Output, signal } from '@angular/core';
import { AuthService } from '@app/common/auth.service';
import { FinancialProductEnum, models } from '../../model/standard-quote.model';
import {Util} from "../../../../../core/util/Util";
import { ActivatedRoute } from '@angular/router';
import { MenusServices } from '@app/services/menus.service';
import { NotificationService } from '@app/services/notifications.service';
import { BaseComponent } from '@app/components/base/base.component';
import { StandardQuoteService } from '../../standard-quote-service.service';
import { environment } from '@env/environment.local';
import { isFinancialSetupCompanyMismatchForQuote } from '../../../open-quote/model/open-quote.model';

@Component({
  template: ''
})
export class RowDealStandardQuoteWrapperComponent extends BaseComponent implements OnInit {
  @Input() indexDeal: number;
  @Input() deal: any;
  @Input() idQuote: any;
  @Input() creationUser: any;
  @Input() model: models;
  @Input() status: any;
  @Input() isValidForm: boolean;
  @Output() isSelected: EventEmitter<any> = new EventEmitter();
  @Output() edit: EventEmitter<any> = new EventEmitter();
  @Output() delete: EventEmitter<any> = new EventEmitter();
  @Output() duplicate: EventEmitter<any> = new EventEmitter();
  @Output() extendValidity: EventEmitter<any> = new EventEmitter();
  collapsed: boolean = true;
  @Input() deals: any[];
  @Input() extendingDealId: number | null = null;
  public readonly authService = inject(AuthService);
  private readonly quoteService = inject(StandardQuoteService);
  openRowOption = signal<string>('');
  readonly featureLoyaltyFeriaQuotation = environment.featureLoyaltyFeriaQuotation;
  readonly showQuoteValidityUi = environment.showQuoteValidityListFilter;

  constructor(
      notification: NotificationService,
      route: ActivatedRoute,
      menuService: MenusServices,
  ) {
    super(route, menuService, notification);
  }
  ngOnInit() {
  }

  viewDeal(indexDeal: any) {
    const element = document.getElementById(
      `deal${indexDeal}`
    ) as HTMLInputElement;
    element.classList.toggle('collapsed');
    this.collapsed = element.classList.contains('collapsed');
  }

  getFinancialProduct(financialProductType: FinancialProductEnum) {
    if (financialProductType == FinancialProductEnum.directCredit) {
      return 'Crédito directo';
    } else if (financialProductType == FinancialProductEnum.financialLeasing) {
      return 'Arrendamiento financiero';
    } else if (financialProductType == FinancialProductEnum.pureLease) {
      return 'Arrendamiento puro';
    }/*else if (financialProductType == FinancialProductEnum.directCreditGlobe) {
      return 'Crédito directo Balloon';
    }*/ else {
      return '';
    }
  }

  showInsuranceVehicle(deal: any) {
    return Util.showInsuranceVehicle(deal);
  }

  /** Ícono Loyalty en lista de propuestas: solo si el paquete tiene `loyaltyFinancialPackage`. */
  showLoyaltyFinancialPackageBadge(deal: any): boolean {
    if (!this.featureLoyaltyFeriaQuotation) {
      return false;
    }
    const v = deal?.financialSetup?.loyaltyFinancialPackage;
    return v === true || v === 'true' || v === 'TRUE';
  }

  /** Misma regla que OD (`canExtendDealValidityInCreditRequest`). */
  canExtendDealValidity(deal: any): boolean {
    if (!this.showQuoteValidityUi) {
      return false;
    }
    if (
      this.creationUser == null ||
      this.authService.currentUserIds == null ||
      String(this.creationUser) !== String(this.authService.currentUserIds)
    ) {
      return false;
    }
    if (!this.isDealExpiredByValidity(deal)) {
      return false;
    }
    if (deal?.isFinancialSetupInactive === true) {
      return false;
    }
    return true;
  }

  isExtendingDealValidity(deal: { id?: number }): boolean {
    return this.extendingDealId != null && this.extendingDealId === deal?.id;
  }

  onExtendDealValidityClick(event: Event, dealId: number): void {
    event.preventDefault();
    event.stopPropagation();
    this.extendValidity.emit(dealId);
  }

  private isDealExpiredByValidity(deal: {
    valid?: boolean | null;
    validityEndDate?: string | Date | null;
  }): boolean {
    const end = deal?.validityEndDate;
    if (end != null && end !== '') {
      const t = new Date(end as string | Date).getTime();
      return !Number.isNaN(t) && t < Date.now();
    }
    return deal?.valid === false;
  }

  formatValidityEndDate(value: unknown): string {
    if (!value) {
      return 'Sin vigencia';
    }
    const date = new Date(value as string | number | Date);
    return Number.isNaN(date.getTime()) ? 'Sin vigencia' : date.toLocaleDateString('es-MX');
  }

  isPackageInactive(deal: any): boolean {
    return deal?.financialSetup?.active === false
      || deal?.isFinancialSetupInactive === true;
  }

  isPackageCompanyMismatch(deal: any): boolean {
    if (deal?.isFinancialSetupCompanyMismatch === true) {
      return true;
    }
    return isFinancialSetupCompanyMismatchForQuote(
      deal?.financialSetup?.companyName,
      this.quoteService.formData?.companyName,
    );
  }

  toggleSelection(event: MouseEvent, index: number,id:number): void {
    const selectedCount = this.deals.filter(deal => deal.isSelected).length;
    const deal = this.deals[index];

    if (this.isPackageInactive(deal)) {
      this.showNotificationError('El paquete financiero no está vigente');
      event.preventDefault();
      return;
    }
    if (this.isPackageCompanyMismatch(deal)) {
      this.showNotificationError(
        'El paquete financiero no está disponible para la compañía de esta cotización',
      );
      event.preventDefault();
      return;
    }

    if (this.deals[index].isSelected) {
      this.deals = this.deals.map((i)=>{return{...i,isSelected: i.id == id ? !this.deals[index].isSelected : i.isSelected}})
      this.isSelected.emit(id)
    } else {
      if (selectedCount >= 6) {
        this.showNotificationError('Ha excedido el número máximo de propuestas permitidas.');
        event.preventDefault();
      } else {
        this.deals = this.deals.map((i)=>{return{...i,isSelected: i.id == id ? !this.deals[index].isSelected : i.isSelected}})
        this.isSelected.emit(id)
      }
    }
  }

  validDealEditable(): boolean {
    const formData : any = this.quoteService.formData;
    let valid = true;
    if(formData.status === 'DRAFT'){
      valid = valid && formData.model.enabled;
    }
    return valid;
  }

  getRowKey(id: string, i: number) {
    return `${id}-${i}`;
  }

  getMobileMenuTriggerId(id: string) {
    return `menu-${id}`;
  }

  isMenuRowOpen(id: string) {
    return this.openRowOption() === id;
  }

  toggleMobileMenuOptions(e: MouseEvent, updated: string) {
    e.preventDefault();
    this.openRowOption.update((value) => (value !== '' ? '' : updated));
  }

  closeMobileMenuOptions() {
    this.openRowOption.set('');
  }

}
